<script>
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import paginationMixin from '../../mixins/pagination';
import ProcedureDirectoryListItem from './components/ProcedureDirectoryListItem';
import NewProcedureDirectoryDialog from './components/NewProcedureDirectoryDialog';
import NewProcedureDirectoriesDialog from './components/NewProcedureDirectoriesDialog';
import RbxConfirmDialog from '../../shared/reybex/RbxConfirmDialog';

export default {
  name: 'ProcedureDirectoryList',
  components: {
    ProcedureDirectoryListItem,
    NewProcedureDirectoryDialog,
    NewProcedureDirectoriesDialog,
    RbxConfirmDialog,
  },
  mixins: [mainViewTabMixin, paginationMixin],
  data() {
    return {
      isInitialized: false,
      headers: [{ text: 'Bezeichnung', value: 'name' }, { text: 'Organisationseinheit', value: 'organizationalUnit' },
        { text: 'Verantwortlicher', value: 'responsibleUser' }, { text: 'Status', value: 'examStatus' }, { text: 'Aktionen', value: '' }],
      showNewProcedureDirectoryDialog: false,
      showNewProcedureDirectoriesDialog: false,
      isConfirmDialogDisplayed: false,
      confirmDeletionMessage: '',
      procedureDirectoryToDelete: {},
      searchTerm: '',
    };
  },
  computed: {
    ...mapState(['procedureDirectoryList']),
    ...mapState('procedureDirectoryList', ['meta']),
  },
  mounted() {
    this.fetchData(this.paginationParams).then(() => {
      this.isInitialized = true;
    });
  },
  methods: {
    ...mapActions('procedureDirectoryList', { fetchData: 'fetchProcedureDirectoryList' }),
    ...mapActions('procedureDirectoryDetails', ['deleteProcedureDirectory']),
    importCsv() {
      axios.post('/procedureDirectoryCsv');
    },
    onDelete(procedureDirectoryToDelete) {
      this.procedureDirectoryToDelete = procedureDirectoryToDelete;
      this.confirmDeletionMessage =
        `Soll das Verfahren ${this.procedureDirectoryToDelete.name} gelöscht werden?`;
      this.isConfirmDialogDisplayed = true;
    },
    onRefuse() {
      this.isConfirmDialogDisplayed = false;
    },
    onConfirm() {
      this.deleteProcedureDirectory(this.procedureDirectoryToDelete)
        .then(() => {
          this.fetchData();
          this.isConfirmDialogDisplayed = false;
        });
    },
    onSearch() {
      this.paginationParams.searchTerm = this.searchTerm;
      this.fetchData(this.paginationParams);
    },
  },
};
</script>

<template>
  <div class="procedureDirectory-list">
    <template v-if="procedureDirectoryList.hasError">
      <p class="js-error-template ma-3">
        Failed to fetch procedureDirectory list. Please try again!
      </p>
    </template>
    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">
        <!--
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="importCsv">
            <v-icon>error_outline</v-icon>
          </v-btn>
          <span>CSV-Import der Vorlagen</span>
        </v-tooltip>
        -->
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="showNewProcedureDirectoryDialog = true">
            <v-icon>add</v-icon>
          </v-btn>
          <span>Neu</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="showNewProcedureDirectoriesDialog = true">
            <v-icon>library_add</v-icon>
          </v-btn>
          <span>Mehrfachanlage</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn @click="fetchData(paginationParams)" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>

        <v-spacer />
        <v-flex md3 >
          <v-text-field
            v-model="searchTerm"
            height="22"
            class="caption"
            placeholder="Suche"
            @keyup.enter="onSearch"
            @blur="onSearch"
          />
        </v-flex>
      </v-toolbar>

      <v-progress-linear
        v-if="procedureDirectoryList.isLoading && !isInitialized"
        :indeterminate="true"
        class="js-loading ma-0"
      />

      <v-data-table
        v-else
        :headers="headers"
        :items="procedureDirectoryList.data"
        :disable-initial-sort="true"
        :pagination="pagination"
        :loading="procedureDirectoryList.isLoading"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="pagination.totalItems"
        :expand="true"
        item-key="id"
        @update:pagination="loadNextPage"
        rows-per-page-text="Zeilen pro Seite"
        no-data-text="keine Daten verfügbar"
        class="elevation-1 js-table"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable',
                       pagination.descending ? 'desc' : 'asc',
                       header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value, procedureDirectoryList.data)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>

        <template slot="items" slot-scope="props">
          <procedureDirectory-list-item
            :procedure-directory="props.item"
            :expanded="props.expanded"
            @delete="onDelete"
          />
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          von {{ pageStart }} bis {{ pageStop }}
        </template>
      </v-data-table>
    </template>

    <NewProcedureDirectoryDialog
      v-if="showNewProcedureDirectoryDialog"
      @cancel="showNewProcedureDirectoryDialog = false"
    />
    <NewProcedureDirectoriesDialog
      v-if="showNewProcedureDirectoriesDialog"
      @cancel="showNewProcedureDirectoriesDialog = false"
    />

    <rbx-confirm-dialog @confirm="onConfirm" @refuse="onRefuse"
                        :message="confirmDeletionMessage"
                        :is-displayed="isConfirmDialogDisplayed" />

  </div>
</template>


<style lang="scss" scoped>
.variant-cell {
  width: 30px;

  i {
    cursor: pointer;
  }
}
</style>
